import React, { FC } from 'react'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { Button } from '@wmgtech/legato'
import { IIsaacLink } from 'shared/interfaces'
import { FormInput } from 'components/FormWithGroup'
import { getIsaacLinkSchema } from '../../utils/issakUtils'

import { IsaakLinkFormProps } from './IsaakLinkForm.props'

const IsaakLinkForm: FC<IsaakLinkFormProps> = ({ onSubmit, onCancel, isaacLinkList }) => {
  const { handleSubmit, control } = useForm<IIsaacLink>({
    resolver: yupResolver(getIsaacLinkSchema(isaacLinkList))
  })

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <FormInput label="Title Description" placeholder="Title" fieldName="title" control={control} />
      <FormInput label="Link" placeholder="https://isaacportal.wmg.com..." fieldName="url" control={control} />
      <div className="create-project-modal__actions">
        <Button label="Cancel" containerStyle="outline" colorType="secondary-black" onClick={onCancel} />
        <Button label="Save" containerStyle="solid" colorType="secondary-black" htmlType="submit" />
      </div>
    </form>
  )
}

export default IsaakLinkForm
